import { Environment } from './environment.interface';

export const environment: Environment = {
    production: true,
    env: "shareda",
    baseUrl: "https://smshareda.instecservices.com",
    applicationEndpoint: "https://smshareda-api.instecservices.com",
    syncHost: "https://smshareda-sync.instecservices.com",
    documentationUrl: "https://smshareda-api-portal.instecservices.com",
    access_token: "",
    applicationInsights: "InstrumentationKey=f7b28ba6-655e-4e00-9b9f-7bcd7348ac9d;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=31953d7e-7802-4e51-a369-690bbe096df0",
    auth: {
        authUri: "https://instecdev.auth0.com",
        clientId: "eGLKbOqdtk2GNRghdT7GbfJhFZnknxVH",
    },
    altLoginEnabled: "true",
    altAuth: {
        authUri: "https://insuritydev.us.auth0.com",
        clientId: "Hblm9d3JV31SfoOEvDIETSTP7waERFCQ"
    },
    qlik: {
        authUrl: "https://insuritybi.dev.insurity.com/sure-uw/hub/",
        reportsUrl: "https://insuritybi.dev.insurity.com/sure-uw/sense/app/e2208206-d9e3-4866-80d7-08d99b623e0f/sheet/681cc4bf-2fea-402e-af05-3e49d7b19ca6/"
    },
    thoughtspot: {
        host: "https://insurity.thoughtspot.cloud"
    },
    ikcDocumentationUrl: "https://docs.insurity.com/category/insurityunderwriting",
    ikcIntegrationDocumentationUrl: "https://docs.insurity.com/bundle/SureUnderwritingUserHelp/page/webhooks.html",
    ikcBureauUrl: "https://docs.insurity.com/bundle/SureCommercialPolicy",
    requireAPIM: true,
    scpAuthClientId: "44970a14-027b-4039-b461-cee8bbb5be4a",
    ApiUrl: '',
    SaaS: true,
    SubscriptionKey: "",
    amplitude: {
        enabled: JSON.parse("true"),
        apiKey: "4880c04fc739e76053a1e13e2bbe4408",
    }
};
